<template>
    <router-view :user="user"></router-view>
</template>

<script>
export default {
    name: "PromoToolsList",
    props: ['user'],
}
</script>